import React from 'react'
import Header from '../../global/Header';
import TeacherProfile from '../../components/ProfilePage/teacherProfile';

export default function ProfilePage () {
    return (
        <>
            <Header/>
            <TeacherProfile/>
        </>
    )
}